import Vue from "vue";
import adminRouter from "./modules/admin";
import authRouter from "./modules/auth";
import accountsRouter from "./modules/accounts";
import transferRouter from "./modules/transfer";
import depositRouter from "./modules/deposit";
import loansRouter from "./modules/loans";
import foreignExchangeRouter from "./modules/foreignExchange";
import customerRouter from "./modules/customer";
import paymentRouter from "./modules/payment";
import Layout from "@/views/layout/layout";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const constantRouter = new VueRouter({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  base: `${process.env.NODE_ENV == "development" ? "/" : "/"}`,
  routes: [
    {
      path: "/init",
      name: "init",
      component: () => import(/* webpackChunkName: "init" */ "@/views/main/init"),
      meta: {
        nation: true,
      },
    },
    {
      path: "/:siteCode/:lang/main",
      name: "main",
      component: () => import(/* webpackChunkName: "main" */ "@/views/main/main"),
      props: true,
      meta: {
        nation: true,
      },
    },
    {
      path: "/intro",
      name: "intro",
      component: () => import(/* webpackChunkName: "intro" */ "@/views/main/intro"),
      meta: {
        nation: true,
      },
    },
    {
      path: "/login",
      component: Layout,
      redirect: "/login",
      children: [
        {
          path: "",
          name: "login",
          component: () => import(/* webpackChunkName: "login" */ "@/views/login/login"),
          meta: {
            transparent: true,
            nation: true,
            goback: false,
            home: true,
          },
        },
      ],
    },
    {
      path: "/example",
      component: Layout,
      children: [
        {
          path: "",
          component: () => import(/* webpackChunkName: "example" */ "@/views/sample/page"),
        },
        {
          path: "/example/:ui",
          name: "sample",
          component: () => import(/* webpackChunkName: "example" */ "@/views/sample/pageDetail"),
          props: true,
        },
      ],
    },
    {
      path: "/noticeService",
      component: Layout,
      redirect: "/noticeService",
      children: [
        {
          path: "",
          name: "noticeService",
          component: () => import(/* webpackChunkName: "noticeService" */ "@/views/templates/common/noticeService"),
        },
      ],
    },
    {
      path: "/joinService",
      component: Layout,
      redirect: "/joinService",
      children: [
        {
          path: "enter",
          name: "joinServiceEnterVtn",
          component: () => import(/* webpackChunkName: "joinService" */ "@/views/templates/common/joinServiceEnterVtn"),
        },
        {
          path: "progress",
          name: "joinServiceProgressVtn",
          component: () => import(/* webpackChunkName: "joinService" */ "@/views/templates/common/joinServiceProgressVtn"),
        },
        {
          path: "complete",
          name: "joinServiceCompleteVtn",
          component: () => import(/* webpackChunkName: "joinService" */ "@/views/templates/common/joinServiceCompleteVtn"),
        },
        {
          path: "duplicate",
          name: "joinServiceDuplicateVtn",
          component: () => import(/* webpackChunkName: "joinService" */ "@/views/templates/common/joinServiceDuplicateVtn"),
        },
        {
          path: "acnoInfo",
          name: "joinServiceAcnoInfoVtn",
          component: () => import(/* webpackChunkName: "joinService" */ "@/views/templates/common/joinServiceAcnoInfoVtn"),
        },
        {
          path: "guide",
          name: "joinServiceGuideVtn",
          component: () => import(/* webpackChunkName: "joinService" */ "@/views/templates/common/joinServiceGuideVtn"),
        },
      ],
    },
    {
      path: "/service",
      component: Layout,
      redirect: { name: "serviceJoinStep1" },
      children: [
        {
          path: "join",
          description: "서비스 이용신청",
          component: () => import(/* webpackChunkName: "service" */ "@/views/templates/common/serviceJoin"),
          redirect: { name: "serviceJoinStep1" },
          children: [
            {
              path: "step1",
              name: "serviceJoinStep1",
              component: () => import(/* webpackChunkName: "service" */ "@/views/templates/common/serviceJoinStep1"),
              meta: {
                roles: ["login"],
                transparent: true,
                step: 1,
                goback: false,
                menu: false,
              },
              children: [
                {
                  path: "detail1",
                  name: "ServiceJoinStep1Contentsogauc",
                  component: () => import(/* webpackChunkName: "service" */ "@/components/page/common/ServiceJoinStep1Contentsogauc"),
                },
                {
                  path: "detail1mmr",
                  name: "ServiceJoinStep1Contentsogmmr",
                  component: () => import(/* webpackChunkName: "service" */ "@/components/page/common/ServiceJoinStep1Contentsogmmr"),
                },
                {
                  path: "detail1vtn",
                  name: "ServiceJoinStep1Contentsogvtn",
                  component: () => import(/* webpackChunkName: "service" */ "@/components/page/common/ServiceJoinStep1Contentsogvtn"),
                },
                {
                  path: "detail1cbd",
                  name: "ServiceJoinStep1Contentsogcbd",
                  component: () => import(/* webpackChunkName: "service" */ "@/components/page/common/ServiceJoinStep1Contentsogcbd"),
                },
              ],
            },
            {
              path: "step2",
              name: "serviceJoinStep2",
              component: () => import(/* webpackChunkName: "service" */ "@/views/templates/common/serviceJoinStep2"),
              meta: {
                roles: ["login"],
                transparent: true,
                step: 2,
                goback: false,
                menu: false,
              },
              children: [
                {
                  path: "detail2auc",
                  name: "ServiceJoinStep2Contentsogauc",
                  component: () => import(/* webpackChunkName: "service" */ "@/components/page/common/ServiceJoinStep2Contentsogauc"),
                },
                {
                  path: "detail2mmr",
                  name: "ServiceJoinStep2Contentsogmmr",
                  component: () => import(/* webpackChunkName: "service" */ "@/components/page/common/ServiceJoinStep2Contentsogmmr"),
                },
                {
                  path: "detail2vtn",
                  name: "ServiceJoinStep2Contentsogvtn",
                  component: () => import(/* webpackChunkName: "service" */ "@/components/page/common/ServiceJoinStep2Contentsogvtn"),
                },
                {
                  path: "detail2cbd",
                  name: "ServiceJoinStep2Contentsogcbd",
                  component: () => import(/* webpackChunkName: "service" */ "@/components/page/common/ServiceJoinStep2Contentsogcbd"),
                },
              ],
            },
            {
              path: "step3",
              name: "serviceJoinStep3",
              component: () => import(/* webpackChunkName: "service" */ "@/views/templates/common/serviceJoinStep3"),
              meta: {
                roles: ["login"],
                transparent: true,
                step: 3,
                goback: false,
                menu: false,
              },
            },
            {
              path: "step4",
              name: "serviceJoinStep4",
              component: () => import(/* webpackChunkName: "service" */ "@/views/templates/common/serviceJoinStep4"),
              meta: {
                roles: ["login"],
                transparent: true,
                goback: false,
                home: true,
              },
            },
          ],
        },
        {
          path: "cancel",
          description: "서비스 이용해지",
          component: () => import(/* webpackChunkName: "service" */ "@/views/templates/common/serviceCancel"),
          redirect: { name: "serviceCancelStep1" },
          children: [
            {
              path: "step1",
              name: "serviceCancelStep1",
              component: () => import(/* webpackChunkName: "service" */ "@/views/templates/common/serviceCancelStep1"),
              meta: {
                roles: ["login"],
              },
            },
            {
              path: "step2",
              name: "serviceCancelStep2",
              component: () => import(/* webpackChunkName: "service" */ "@/views/templates/common/serviceCancelStep2"),
              meta: {
                roles: ["login"],
                goback: false,
                home: true,
              },
            },
          ],
        },
      ],
    },

    adminRouter,
    accountsRouter,
    transferRouter,
    depositRouter,
    foreignExchangeRouter,
    loansRouter,
    customerRouter,
    authRouter,
    paymentRouter,
    {
      path: "error",
      redirect: { name: "errorPage" },
      component: Layout,
      children: [
        {
          path: "page",
          name: "errorPage",
          component: () => import(/* webpackChunkName: "error" */ "@/views/templates/common/errorPage"),
          props: true,
          meta: {
            transparent: true,
            goback: false,
          },
        },
      ],
    },
    {
      path: "*",
      redirect: { name: "errorPage" },
    },
  ],
});

export default constantRouter;
